var State = {
  filter_controller: null,
  task_editor_opened: false,
  itask_editor_opened: false
}

export default State;